import React from "react";

import { GridColumn } from "@progress/kendo-react-grid";
import { checkBoxCell, customCell, GridPanel, IRoutedTabProps } from "@selas/ui-components";
import { useTranslation } from "react-i18next";

import Endpoint from "../../../services/api/endpoint";
import { hasPermission } from "../../../services/authentication";
import { Permission } from "../../../utils/enums";
import TaskSubjectEditor from "../../editors/masterdata/taskSubject";

const TaskSubjects: React.FC<IRoutedTabProps> = () => {
	const { t } = useTranslation();

	return (
		<GridPanel
			listEndpoint={Endpoint.TaskSubjectsList}
			endpoint={Endpoint.TaskSubjects}
			addScreen={{ screen: TaskSubjectEditor, isAllowed: hasPermission(Permission.TaskSubjectsAdd) }}
			editScreen={{ screen: TaskSubjectEditor, isAllowed: hasPermission(Permission.TaskSubjectsUpdate) }}
			delete={{ isAllowed: hasPermission(Permission.TaskSubjectsDelete) }}
			filter={{
				logic: "and",
				filters: [
					{
						field: "active",
						operator: "eq",
						value: true
					}
				]
			}}
		>
			<GridColumn field="name" title={t("name")} />
			<GridColumn field="active" title={t("active")} filter="boolean" width="160px" cell={customCell(checkBoxCell())} />
		</GridPanel>
	);
};

export default TaskSubjects;
